module.exports = __webpack_public_path__ + "static/media/Icon_GarageDoor.567af4fd.png";